import { Component } from '@angular/core';

@Component({
    selector: 'jhi-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})
export class ErrorComponent {

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/error/error.component.ts